// extracted by mini-css-extract-plugin
module.exports = {"heroBody":"styles_heroBody__11drA","featureImage":"styles_featureImage__242_Y","demoContainer":"styles_demoContainer__3geZq"};